import {
  AVATAR_INITIALS_LARGE_MIN_SIZE,
  AVATAR_INITIALS_MEDIUM_MIN_SIZE,
  AVATAR_INITIALS_VARIANT,
} from './UserAvatar.constants';

export const getInitialsVariant = size => {
  const numericSize = Number(size);

  if (numericSize >= AVATAR_INITIALS_LARGE_MIN_SIZE) {
    return AVATAR_INITIALS_VARIANT.LARGE;
  }

  if (numericSize >= AVATAR_INITIALS_MEDIUM_MIN_SIZE) {
    return AVATAR_INITIALS_VARIANT.MEDIUM;
  }

  return AVATAR_INITIALS_VARIANT.DEFAULT;
};

export const getInitialsColor = ({ isNativeMobile, isDarkWeb }) => {
  if (isNativeMobile) {
    return 'primary.contrastText';
  }

  // Dark initials read clearly on the dark-web accent gradient; light keeps primary text.
  if (isDarkWeb) {
    return 'background.primary';
  }

  return 'text.primary';
};
